import { AsYouType, isValidPhoneNumber as libIsValidPhoneNumber } from 'libphonenumber-js'
import pluralize from 'pluralize'
import phoneCodes from './countrycodesToPhone.json'
import countrycodeNames from './countrycodesToName.json'

export const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1)

export const formatPhoneNumber = (str: string): { countryCode?: string; phoneNumber: string } => {
    const phone = new AsYouType({ defaultCallingCode: '1' })
    phone.input(str)
    return {
        countryCode: phone.getCallingCode(),
        phoneNumber: phone.getNationalNumber(),
    }
}
const COUNTRY_CODES = Object.keys(countrycodeNames || {})
type CountryNameDictionary = typeof countrycodeNames
type CountryCode = keyof CountryNameDictionary

const isCountryCode = (value: string): value is CountryCode => {
    return COUNTRY_CODES.includes(value)
}
export const COUNTRY_CODE_LIST: Array<{
    name: string
    code: CountryCode
    prefix: string
}> = Object.entries(phoneCodes).map(([code, prefix]) => {
    if (!isCountryCode(code)) throw new Error(`Invalid country code ${code}`)
    let sanatizedPrefix = prefix
    if (!prefix.length || !prefix.includes('+')) {
        sanatizedPrefix = prefix.replace('+', '')
    }
    return {
        name: countrycodeNames[code],
        prefix: sanatizedPrefix,
        code,
    }
})

export const isValidPhoneNumber = (value: string): boolean => {
    return libIsValidPhoneNumber(value)
}

export const formatPlural = (params: { value: string; count: number }): string => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return pluralize(params.value, params.count)
}

export const safeParseInt = (val: string): number | null => {
    const parsed = parseInt(val, 10)
    if (Number.isNaN(parsed)) {
        return null
    }
    return parsed
}

/**
 * Removes all whitespaces from a string, both in and outside
 * @param value
 * @returns
 */
export const removeSpaces = (value: string): string => value.replace(/\s/g, '')

export const decodeUTF8 = (utf8Array: Uint8Array): string => {
    return new TextDecoder('utf-8').decode(utf8Array)
}

export const encodeUri = (value: string): string => {
    const encodedUri = encodeURI(value)
    return encodedUri
}
